import "./index.scss";

const MiniModal = ({ text, variant = "yellow", position = "center" }) => {
  return (
    <div
      className={`mini-modal mini-modal--${variant} mini-modal--pos-${position}`}
    >
      <p>{text}</p>
    </div>
  );
};

export default MiniModal;
